// extracted by mini-css-extract-plugin
export default {"subtitle":"RejectedFilesModal__subtitle___rbogA","fileListContainer":"RejectedFilesModal__fileListContainer___PgrDT","footerContainer":"RejectedFilesModal__footerContainer___NT5rs"};